import { Text } from '@vouched.id/vault';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DebugDropdowns } from '../Debug/DebugDropdowns';
import { FilesDropdown } from '../Files/FilesDropdown';
import { ReviewDropdowns } from '../Review/ReviewDropdowns';
import { ScoresDropdown } from '../Scores/ScoresDropdown';
import { useJobSectionTitleStyles } from '../utils';
import { ReverificationCompletedResult } from './ReverificationCompletedResult';
import { useGlobalState } from 'store/reducers/reducer';
import { loadJob } from 'store/sagas/sagas';
import { roundNumber } from 'utils/ui.utils';
export const ReverificationDropdowns = ({ jobResult, jobErrors, jobStatus, jobReview, onReviewSubmitted, jobSid, debugDropdownVisible, filesDropdownVisible, jobDebugResults, jobRequestParams, jobRequestInfo, rejectionReasons }) => {
    const confidences = jobResult?.confidences;
    const jobSectionTitleStyles = useJobSectionTitleStyles();
    const { asyncDispatch } = useGlobalState();
    const { pathname } = useLocation();
    const isAdmin = pathname.includes('/admin');
    const [parentJob, setParentJob] = useState(undefined);
    useEffect(() => {
        const parentJobSid = jobRequestParams?.id;
        if (parentJobSid) {
            asyncDispatch(loadJob(parentJobSid, isAdmin)).then(setParentJob, console.error);
        }
    }, [jobRequestParams?.id, isAdmin]);
    return (React.createElement(React.Fragment, null,
        !!jobResult && (React.createElement(ReverificationCompletedResult, { jobErrors: jobErrors, jobRequestInfo: jobRequestInfo, jobResult: jobResult, jobStatus: jobStatus, parentJob: parentJob, rejectionReasons: rejectionReasons })),
        React.createElement(Text, { style: jobSectionTitleStyles }, "Other"),
        !!confidences && (React.createElement(ScoresDropdown, { faceMatch: roundNumber(confidences.faceMatch) ?? undefined, selfie: roundNumber(confidences.selfie) ?? undefined })),
        !!confidences && (React.createElement(ReviewDropdowns, { isReverificationJob: true, jobConfidences: confidences, jobErrors: jobErrors, jobReview: jobReview, jobSid: jobSid, onReviewSubmitted: onReviewSubmitted, rejectionReasons: rejectionReasons })),
        filesDropdownVisible && (React.createElement(FilesDropdown, { fileNamePrefix: "Reverification", jobStatus: jobStatus, showConfidencesToggle: false })),
        debugDropdownVisible && (React.createElement(DebugDropdowns, { jobDebugResults: jobDebugResults }))));
};
